module.exports = "/static/assets/bd7f87fab548492fc7bb81e2a1fe5681.png";